<form class="flex flex-col gap-3">
  <div class="flex flex-col gap-2" [formGroup]="searchForm()">
    @let initialParams = initialParams$ | async;

    @if (initialParams) {
      <homey-household-size-input [control]="searchForm().controls.householdSize"/>
      <homey-income-option-select [control]="searchForm().controls.householdIncome"/>
    }
  </div>
</form>

<div class="h-[200px]">
  @let apartments = apartmentSearchResult.value();
  @if (apartments && !apartmentSearchResult.isLoading()) {
      <p-divider align="center" [dt]="dividerDt()">
        <p class="text-surface-500 text-sm">
        {{ apartments.length }} results
      </p>
    </p-divider>
    @if (apartments.length === 0) {
      <p class="mb-8">No apartments found meeting the specified criteria</p>
    } @else {
      <homey-lotteries-carousel [lotteries]="apartments"
                                [apartmentRoute]="route()"
                                [relevantApartmentsInput]="relevantApartmentsInput()"></homey-lotteries-carousel>
    }
  } @else {
    <p-divider [dt]="dividerDt()">
      <p class="text-surface-500 text-sm">Loading</p>
    </p-divider>
    <p-skeleton height="12rem"/>
  }
</div>
